import i18n from 'modules/core/lib/i18n'

import type Group from 'modules/reviews/store/models/Group'

export function getGroupName(group: Group | null | undefined): string | undefined {
  if (!group) return 'Group'

  return {
    self: i18n.t('surveys.review.questions.question_groups.self'),
    manager: i18n.t('surveys.review.questions.question_groups.manager'),
    reportees: i18n.t('surveys.review.questions.question_groups.reportees'),
    peers: i18n.t('surveys.review.questions.question_groups.peers'),
    manual: i18n.t('surveys.review.questions.question_groups.manual'),
  }[group.attributes.name as string]
}
